import React from 'react';

import { Ball, Icons } from 'widget/components';
import { getUtm, isolateNumbers } from 'widget/actions';
import { useWidgetContext } from 'widget/widget-context';
import * as Env from 'widget/env';

const Socials = () => {
  const { widget } = useWidgetContext();

  const getHref = (social: Env.WidgetSocial) => {
    if (social.version != 'whatcrm') return social.url;
    else if (isNaN(Number(social.url))) return social.url;

    const utm = getUtm();
    const params = new URLSearchParams(utm);

    const phone = isolateNumbers(social.url);
    const source_url = `${window.location.href}?${params}`;

    return `https://api.whatsapp.com/send?phone=${phone}&source_url=${source_url}`;
  };

  return (
    <>
      {widget.socials.map(social => (
        <React.Fragment key={social.version}>
          {social.url && (
            <Ball href={getHref(social)}>
              {social.version == 'facebook' ? (
                <Icons.Facebook />
              ) : social.version == 'instagram' ? (
                <Icons.Instagram />
              ) : social.version == 'linkedin' ? (
                <Icons.LinkedIn />
              ) : social.version == 'max' ? (
                <Icons.Max />
              ) : social.version == 'telegram' ? (
                <Icons.Telegram />
              ) : social.version == 'twitter' ? (
                <Icons.Twitter fill="black" />
              ) : social.version == 'vk' ? (
                <Icons.Vk />
              ) : social.version == 'whatcrm' ? (
                <Icons.WhatsApp />
              ) : (
                <Icons.AtMail />
              )}
            </Ball>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

export default Socials;
